import { render, staticRenderFns } from "./report-datacharts.vue?vue&type=template&id=24f82c35&scoped=true&"
import script from "./report-datacharts.vue?vue&type=script&lang=js&"
export * from "./report-datacharts.vue?vue&type=script&lang=js&"
import style0 from "./report-datacharts.vue?vue&type=style&index=0&id=24f82c35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f82c35",
  null
  
)

export default component.exports